import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import persistState from 'redux-localstorage';
import reservationMiddleware from '../modules/reservation/middleware';
import rootReducer from './reducers';

/**
 * Get only the form values from local storage
 *
 * @param {Any} paths
 */
const stateSlicer = () => (state) => {
  if (state.reservation) {
    // TODO check the `book_date` of the reservation to determine if the reservation
    // should be passed to the state or not.
    return {
      reservation: state.reservation,
    };
  }
  return {};
};

const configureStore = (preloadedState) => {
  const middleware = [
    thunkMiddleware,
    reservationMiddleware,
    // routerMiddleware(history),
  ];

  const store = createStore(
    rootReducer,
    preloadedState,
    compose(
      applyMiddleware(...middleware),
      typeof localStorage !== 'undefined'
        ? persistState('reservation', {
          key: 'beeksebergen-booking',
          slicer: stateSlicer,
        })
        : f => f,
      typeof window !== 'undefined'
        && (process.env.RAZZLE_ENV !== 'production' && process.env.RAZZLE_ENV !== 'staging')
        && window.__REDUX_DEVTOOLS_EXTENSION__
          ? window.__REDUX_DEVTOOLS_EXTENSION__()
          : f => f
    )
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      // eslint-disable-next-line global-require
      const nextRootReducer = require('./reducers').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};

export default configureStore;
